import * as React from 'react'

import type {AgentPoolId} from '../../../../../../types'
import {useShowState} from '../../AgentPoolPage.hooks'
import DialogTrigger from '../../DialogTrigger/DialogTrigger'

import AssignProjectsDialog from './AssignProjectsDialog/AssignProjectsDialog'

type Props = {
  agentPoolId: AgentPoolId
  agentPoolName: string
  className?: string | undefined
}

function AssignProjectsButton({
  agentPoolId,
  agentPoolName,
  className,
}: Props): React.ReactElement | null {
  const [show, setShow, setHide] = useShowState()

  return (
    <DialogTrigger
      className={className}
      triggerTitle="Assign projects..."
      title={`Assign projects to ${agentPoolName}`}
      onShow={setShow}
      onHide={setHide}
      show={show}
    >
      <AssignProjectsDialog agentPoolId={agentPoolId} onCloseAttempt={setHide} />
    </DialogTrigger>
  )
}

export default React.memo(AssignProjectsButton)
